import { useRemoteClientPost } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { useLocalStorage } from '@/remote/local-storage'
import { PaginationDemo } from '@/view/components/pagination'
import { TableGroups } from '@/view/components/table-groups'
import { usePagination } from '@/view/hooks'
import { usePromiseToast } from '@/view/hooks/toast-promisse'
import { GroupsFormData } from '@/view/validators/groups-validator'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export function DisplayGroups() {
  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [data, setData] = useState<GroupsFormData[]>([])
  const [params] = useSearchParams()
  const [controlPage, setControlPage] = useState(0)

  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0
  })
  const quantityForPage = 10

  const getNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const getBackPage = () => {
    backPage(pageInfo.page, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const fetchData = async () => {
    try {
      const response = await httpClientPost(`${Endpoints.gruops}/filtro?page=${controlPage}&size=${quantityForPage}&order=desc&sort=id`, {
        idUnidade: params.get('id') ?? getUnitId()
      })

      const data = response?.data?.data ?? {}
      const content = data?.content ?? []
      const page = data?.pageable?.pageNumber ?? 0
      const totalPages = data?.totalPages
      const total = data?.totalElements
      //console.log(page, totalPages, total)

      setData(content)
      setPageInfo({
        page: page,
        total: total,
        totalPages: totalPages
      })
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
    }
  }

  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  useEffect(() => {
    handleRefresh()
  }, [controlPage, params])

  return (
    <>
      <TableGroups data={data} height=" h-[calc(100vh-370px)]" getRefreshList={handleRefresh} />
      <PaginationDemo totalForPage={quantityForPage} back={getBackPage} next={getNextPage} page={pageInfo.page} total={pageInfo.total} labelItem="Grupos musculares cadastrados" />
    </>
  )
}
